import { api } from 'domains/api';
import { getProxyAPIRoute, PROXY_API_ROUTES } from 'domains/api/proxy/routes';
import {
  CreateSignupV2LeadPayload,
  PartialSignupLeadV2,
  SignupLeadProgressV2,
  SignupLeadV2,
} from 'domains/signupv2/Leads/types';

export type CreateLeadResponseV2 = Pick<SignupLeadV2, 'id' | 'schedulingId'>;

export const createSalesforceLead = (payload: CreateSignupV2LeadPayload) => {
  return api.proxy.post<CreateLeadResponseV2>(getProxyAPIRoute(PROXY_API_ROUTES.salesforce.leads.v2), payload);
};

export const updateSalesforceLead = (payload: PartialSignupLeadV2) => {
  return api.proxy
    .put<CreateLeadResponseV2>(getProxyAPIRoute(PROXY_API_ROUTES.salesforce.leads.base), payload)
    .then(response => {
      return response.id;
    });
};

export const getSalesforceLead = (leadID: string) => {
  return api.proxy.get<SignupLeadProgressV2>(
    getProxyAPIRoute(PROXY_API_ROUTES.salesforce.leads[':leadID'].progress, { leadID }),
  );
};
